export enum AXIOS_URLS {
  auth = 'auth',
  users = 'users',
  technicians = 'technicians',
  pdf_certificates = 'pdf-certificates',
  service_stations = 'service-stations',
  serial_numbers = 'serial-numbers',
  external_calibrations = 'external-calibrations',
}

export default {
  baseURL: process.env.REACT_APP_PUBLIC_BASE_URL as string,
};
